export default (axios, checkHeaders) => ({
  getList (data = {}) {
    return axios.get('/webhooks', { params: data.filters || {} })
  },
  postOne (data = {}) {
    return axios.post('/webhook', data.body, { params: data.filters || {} })
  },
  getOne (data = {}) {
    return axios.get('/webhook/' + data.id, { params: data.filters || {} })
  },
  patchOne (data = {}) {
    return axios.patch('/webhook/' + data.id, data.body, { params: data.filters || {} })
  },
  deleteOne (data = {}) {
    return axios.delete('/webhook/' + data.id, { params: data.filters || {} })
  },
  getActions (data = {}) {
    return axios.get('/webhook-actions', { params: data.filters || {} })
  }
})
